import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../../ValidateError';


const server_backend = config.API_URL;

function CreateMaterial({ username, onClose }) {
    const [loading, setLoading] = useState(false);
    const [MetalList, setMetalList] = useState([]);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        matt_id: "",
        purity: "",
        unit: "",
        price: "",
        reference: "",
        comment: "",
        user_transaction: username,
        color: "",

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        const getMetal = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);

                if (response.data.RES_CODE === "00") {
                    setMetalList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMetal();
    }, []);


    const handleCreate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/materials/insert`, formData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate('/materials');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Material already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <center>
                                <h4>Create Material</h4>
                            </center>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <Link className='btn btn-warning' to="/materials" onClick={onClose}>Go Back</Link>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Material name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-6">
                                        <div className="mb-3">
                                            <label htmlFor="matt_id" className="form-label">Material type</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="matt_id"
                                                value={formData.matt_id}
                                                onChange={handleChange}
                                            ><option>Select the type of metal</option>
                                                {MetalList.map((Metal_R) => (
                                                    <option key={Metal_R.matt_ID} value={Metal_R.matt_ID}>
                                                        {Metal_R.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <br />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="purity" className="form-label">Purity</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Purity"
                                            name="purity"
                                            value={formData.purity}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="unit" className="form-label">Unit</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Unit"
                                            name="unit"
                                            value={formData.unit}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="price" className="form-label">Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Price"
                                            name="price"
                                            value={formData.price}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="reference" className="form-label">Reference</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Reference"
                                            name="reference"
                                            value={formData.reference}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="color" className="form-label">Color</label>
                                        <input
                                            type="color"
                                            className="form-control form-control-color"
                                            id="color"
                                            name="color"
                                            value={formData.color}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="comment" className="form-label">Comment</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter comment"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Creating..." : "Create"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default CreateMaterial;
